namespace advisorop.domains {

    export interface IQuestionnaire {
        id: number;
        name: string;
        isActive: boolean;
        questions: Array<IQuestion>;
    }

    export class Questionnaire implements IQuestionnaire {
        public id: number;
        public name: string;
        public isActive: boolean;
        public questions: Array<IQuestion>;
    }

    export interface IQuestion {
        id: number;
        questionnaireId: number;
        no: number;
        text: string;
        questionType: number;
        options: Array<IQuestionOption>;
    }

    export class Question implements IQuestion {
        public id: number;
        public questionnaireId: number;
        public no: number;
        public text: string;
        public questionType: number;
        public options: Array<IQuestionOption>;
    }
    
    export interface IQuestionOption {
        id?: number;
        questionId?: number;
        no?: number;
        text?: string;        
        points?: number;
        question?: domains.IQuestion;
        imageUrl?: string;
    }

    export class QuestionOption implements IQuestionOption {
        public id: number;
        public questionId: number;
        public no: number;
        public text: string;        
        public points: number;
        public question: domains.IQuestion;
    }

    export interface IQuestionResult {
        id: number;
        questionType: number;
        questionnaireResultId: number;
        questionId: number;
        optionId: number;        
        textAnswer: string;
        dateAnswer: Date;
        numericAnswer: number;
        points: number;
    }

    export class QuestionResult implements IQuestionResult {

        constructor(questionId) {
            this.questionId = questionId;
        }

        public id: number;       
        public questionType: number;
        public questionnaireResultId: number;
        public questionId: number;
        public optionId: number;
        public textAnswer: string;
        public dateAnswer: Date;
        public numericAnswer: number;
        public points: number;
    }
    
    export interface IQuestionnaireResult {
        id: number;
        status: number;
        questionnaireId: number;
        dateStart: Date;
        dateChanged: Date;
        dateFinished: Date;
        results: Array<domains.IQuestionResult>;
        questionnaire: IQuestionnaire;
    }

    export class QuestionnaireResult implements IQuestionnaireResult {
        
        public id: number;
        public status: number;
        public questionnaireId: number;
        public dateStart: Date;
        public dateChanged: Date;
        public dateFinished: Date;
        public results: Array<domains.IQuestionResult>;
        public questionnaire: IQuestionnaire;
    }


}